import * as React from 'react'
import './styles.css'
// libs
import { motion } from 'motion/react'
// components
import Glow from '../../../../glows'
import Automatically from '../Automatically'
import LearnMoreButton from '../LearnMoreButton'
import AnimatedContainer from '../../../../ui/AnimatedContainer/animatedContainer'
// views
import {
  titleAnimation,
  subtitleAnimation,
} from '../../../../../constants/animation'

const PodAutomaticallySection = () => (
  <section className='recruiting-content'>
    <div className='box'>
      <Glow position='right' />

      <AnimatedContainer className='recruiting-grid-container recruiting-automatically-grid'>
        <div>
          <motion.p className='recruiting-main-title' variants={titleAnimation}>
            Automatically...
          </motion.p>
          <motion.p
            className='recruiting-sub-content-container'
            variants={subtitleAnimation}
          >
            <span>
              ...pipeline candidates to internal departments for easy
              consumption
            </span>
            <span>
              ...earmark promising candidates for emerging opportunities
            </span>
            <span>...communicate with and qualify candidates</span>
          </motion.p>
          <div className='recruiting-button-container'>
            <LearnMoreButton />
          </div>
        </div>

        <div className='recruiting-automatically-section'>
          <Automatically />
        </div>
      </AnimatedContainer>
    </div>
  </section>
)

export default PodAutomaticallySection
